module.exports = __webpack_public_path__ + "static/img/platform_advantages2.e7ae9bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/platform_advantages2.png
// module id = eWAg
// module chunks = 2